import axios from "axios";

//update SERVERBASEURL to 'http://localhost:2550';
export const SERVERBASEURL = 'https://brouseserver.herokuapp.com';

const APIKEY = "563ed026dcec4736abbf716e2b53583d";
const NEWSBASEURL = "https://newsapi.org/v2/top-headlines?country=in&category=business&apiKey=";

export const server_url = axios.create({
    baseURL: SERVERBASEURL
});

export const news_url = axios.create({
    baseURL: NEWSBASEURL + APIKEY
});